// extracted by mini-css-extract-plugin
export default {"banner":"BankLoanBanner_banner__UlykE","imgDiv":"BankLoanBanner_imgDiv__qx4zf","aCenter":"BankLoanBanner_aCenter__Ci9hs"};